import React, { useEffect, useState } from "react";
import XLSX from "xlsx-populate";
import { saveAs } from "file-saver";
import { CSVLink } from "react-csv";

// NOTE: The old react-export-excel is not maintained and can install since getting submodule error so switched to new library
// to verify visit https://www.npmjs.com/package/react-export-excel
export const ExcelDownload = ({
  filename = "data",
  dataSet = [],
  columnKeys = [],
  element,
}) => {
  const handleDownload = async () => {
    // Check if dataSet or columnKeys is empty and log an error
    if (dataSet.length === 0 || columnKeys.length === 0) {
      console.error("Error: No data or columns available.");
      return; // Prevent further execution if data is missing
    }

    try {
      // Initialize a new workbook
      const workbook = await XLSX.fromBlankAsync();
      const sheet = workbook.sheet(0);

      // Add the header row from columnKeys
      columnKeys.forEach((key, index) => {
        sheet.cell(1, index + 1).value(key.text); // Use key.text for the header
      });

      // Add data rows from dataSet
      dataSet.forEach((row, rowIndex) => {
        columnKeys.forEach((key, colIndex) => {
          sheet
            .cell(rowIndex + 2, colIndex + 1)
            .value(row[key.dataField] || ""); // Use key.dataField for the data
        });
      });

      // Convert the workbook to a Blob
      const excelBuffer = await workbook.outputAsync();
      const blob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      // Save the file
      saveAs(blob, `${filename}.xlsx`);
    } catch (error) {
      console.error("Error creating Excel file:", error);
    }
  };

  return (
    <span onClick={handleDownload}>
      {element || (
        <button style={{ padding: "10px", cursor: "pointer" }}>
          Download Excel
        </button>
      )}
    </span>
  );
};
export const CSVDownload = ({
  headers = [],
  data = [],
  filename,
  csvRef,
  onClicked,
}) => {
  const [toggleData, setToggleData] = useState(data);
  useEffect(() => {
    setToggleData(toggleData);
  }, [data]);
  return (
    <CSVLink
      data={toggleData}
      filename={filename}
      target="_blank"
      ref={csvRef}
      headers={headers}
      asyncOnClick={true}
      onClick={(event, done) => onClicked(event, done)}
    >
      <img
        alt="..."
        style={{ width: "40px", height: "43.5px" }}
        src={require("assets/img/icons/common/csv.png")}
      />
    </CSVLink>
  );
};
